import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51ee1b0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PlatformMain" }


import FeaturedFirst from './FeaturedFirst.vue'
import PlatformArticle from './PlatformArticle.vue'
import LikeShop from '@/components/common/LikeShop.vue'
import LikeGoods from '@/components/common/LikeGoods.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  navItem: {
    type: Object,
    default: null
  }
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(FeaturedFirst, {
      type: __props.navItem.value
    }, null, 8, ["type"]),
    _createVNode(PlatformArticle, {
      frogArticleType: __props.navItem.frogArticleType
    }, null, 8, ["frogArticleType"]),
    _createVNode(LikeShop, {
      channel: "2",
      platformType: __props.navItem.platformType
    }, null, 8, ["platformType"]),
    _createVNode(LikeGoods, {
      channel: "2",
      platformType: __props.navItem.platformType
    }, null, 8, ["platformType"])
  ]))
}
}

})